import { ElementDetails } from "@/lib/types";
import { SlackStatusProps } from "./types";

export const details = {
  name: "SlackStatus",
  description: "Your Slack profile and custom status at a glance",
  tags: ["Communication"],
  category: "Slack",
  grid: { default: [3, 3], large: [4, 3] },
  gridNames: { default: "Medium", large: "Large" },
  integrationsUsed: ["slack"],
  defaultProps: {},
} as ElementDetails<SlackStatusProps>;
